import { createAction } from 'redux-act';
import { GET } from 'gandi.redux-fetcher';
import { selectOneProductByFQDN } from '../../selectors';
export const fetchAuthInfosStart = createAction('fetching authInfos');
export const fetchAuthInfosSuccess = createAction('authInfos received');
export const fetchAuthInfosFail = createAction('authInfos not received');
export const fetchAuthInfos = fqdn => (dispatch, getState) => {
  const product = selectOneProductByFQDN(getState(), {
    fqdn
  });
  if (!product) {
    return Promise.resolve();
  }
  const productId = product.id;
  dispatch(fetchAuthInfosStart(productId));
  return dispatch(GET(`/domain/authinfos/${fqdn}`, {
    on2XX: response => {
      dispatch(fetchAuthInfosSuccess({
        productId,
        data: response.data
      }));
    },
    not2XX: () => {
      dispatch(fetchAuthInfosFail(productId));
    }
  }));
};